import { Progress, ProgressBar } from '@/shared/components/Progress'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { cn } from '@/shared/lib/utils'

export default function ProgressRow({
	label,
	onClick,
	absoluteValue,
	relativeValue,
	extraValue,
	barClassName,
	disableTooltip,
}: {
	onClick?: () => void
	label: string
	relativeValue: number
	absoluteValue: number | string
	extraValue?: number | string
	barClassName?: string
	disableTooltip?: boolean
}) {
	return (
		<div className='flex w-full flex-col'>
			<div
				onClick={onClick}
				className={cn(
					'mb-1 flex items-center justify-between text-sm font-normal',
					{
						'cursor-pointer hover:text-primary hover:underline': !!onClick,
					}
				)}
			>
				<span>{label}</span>
				{disableTooltip ? (
					<span>
						{absoluteValue} {extraValue !== undefined ? `(${extraValue})` : ''}
					</span>
				) : (
					<Tooltip>
						<TooltipTrigger asChild>
							<span>
								{absoluteValue}{' '}
								{extraValue !== undefined ? `(${extraValue})` : ''}
							</span>
						</TooltipTrigger>
						<TooltipContent>{`SKUs ${extraValue !== undefined ? '(PLs)' : ''}`}</TooltipContent>
					</Tooltip>
				)}
			</div>
			<Progress>
				<ProgressBar className={barClassName} value={relativeValue} />
			</Progress>
		</div>
	)
}
